<template>
	<div class="item-params">
		<DynamicParamsDispatcher
			:interfaceFieldUUID="widgetFieldUUID"
			:action="action"
			:service="service"
			:params="params"
			@send-params-map="onParamsMapChange"
			@send-params-map-labels="onParamsMapLabelsChange"
		/>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ParamsService from '@/utils/ParamsService';
import { getWidgetFieldData } from '@/store/modules/widgets/getters';
import { getConfigurationFieldResponse } from '@/store/modules/workflowConfigurations/getters';
import { saveConfigurationFieldResponse } from '@/store/modules/workflowConfigurations/actions';
import { getConfigurationAndInterfaceIdByFieldUUID } from '@/store/modules/selectedWorkflow/modules/configurations/getters';

export default {
	name: 'MapperBaseParamsEditorDispatcher',
	props: {
		widgetFieldUUID: { type: String },
		service: { type: Object },
		fieldItem: { type: String },
	},
	components: {
		DynamicParamsDispatcher: () => import('@/components/BlockEditorWidget/WidgetFields/DynamicDataMapping/DynamicParamsDispatcher'),
	},
	computed: {
		...mapGetters([
			getWidgetFieldData.fullPath,
			getConfigurationFieldResponse.fullPath,
			getConfigurationAndInterfaceIdByFieldUUID.fullPath,
		]),
		mapperData() {
			return this[getWidgetFieldData.fullPath](this.widgetFieldUUID)?.widgetField || {};
		},
		existingParams() {
			return this.mapperData?.metadata?.source?.params_map || {};
		},
		action() {
			return { mapped_resource: this.fieldItem };
		},
		params() {
			return ParamsService.getParamsForMappingByItem(this.service, this.fieldItem);
		},
		configurationAndInterfaceIdByFieldUUID() {
			return this[getConfigurationAndInterfaceIdByFieldUUID.fullPath](this.widgetFieldUUID);
		},
		configurationId() {
			return this.configurationAndInterfaceIdByFieldUUID.configurationId;
		},
		interfaceUUID() {
			return this.configurationAndInterfaceIdByFieldUUID.interfaceUUID;
		},
		interface() {
			return this.configurationAndInterfaceIdByFieldUUID.interface;
		},
		creatorMapResponse() {
			return this[getConfigurationFieldResponse.fullPath](this.configurationId, this.widgetFieldUUID) || {};
		},
	},
	methods: {
		...mapActions([saveConfigurationFieldResponse.fullPath]),
		async onParamsMapChange(value) {
			if (Object.keys(value).length > 0) {
				this.localResponse = { ...this.localResponse, params_map: value };
				await this[saveConfigurationFieldResponse.fullPath]({
					id: this.configurationId,
					interfaceUUID: this.interfaceUUID,
					fieldUUID: this.widgetFieldUUID,
					response: this.localResponse,
				});
			}
			this.$emit('send-params-map');
		},
		async onParamsMapLabelsChange(value) {
			if (Object.keys(value).length > 0) {
				this.localResponse = { ...this.localResponse, params_map_labels: value };
				await this[saveConfigurationFieldResponse.fullPath]({
					id: this.configurationId,
					interfaceUUID: this.interfaceUUID,
					fieldUUID: this.widgetFieldUUID,
					response: this.localResponse,
				});
			}
			this.$emit('send-params-map-labels');
		},
	},
	mounted() {
		this.localResponse = this.creatorMapResponse;
	},
	data() {
		return {
			localResponse: {},
		};
	},
};
</script>

<style lang="scss" scoped>
.mapper-name {
	.name-title {
		font-size: 18px;
		font-weight: 400;
	}
	.name-sub-title {
		font-size: 10px;
	}
	.name-block {
		font-size: 12px;
	}
}
</style>
